export default __webpack_public_path__ + "static/media/band12.a0679ab3.jfif";